import styled from '@emotion/styled';
import { NodeData } from 'react-folder-tree';
import { v4 as uuidv4 } from 'uuid';

export const TaskInformation = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 15px 0px 0px 15px;
  min-height: 20px;
  border-radius: 5px;
  width: 350px;
  background: white;
  margin-top: 15px;
  margin-right: 10px;
`;

export const TaskInformationBloco = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 15px 0px 0px 15px;
  min-height: 20px;
  border-radius: 5px;
  min-width: 800px;
  background: white;
  margin-top: 15px;
  margin-right: 10px;
`;

export const TaskList = styled.div`
  min-height: 100px;
  display: flex;
  flex-direction: column;
  background: #f3f3f3;
  min-width: 250px;
  border-radius: 5px;
  padding: 15px 15px;
  max-height: 610px;
  min-height: 300px;
  overflow: auto;
`;

export const Title = styled.span`
  color: #10957d;
  background: rgba(16, 149, 125, 0.15);
  padding: 2px 10px;
  border-radius: 5px;
  align-self: flex-start;
`;

export function values_nfe() {

  let order = 0

  /**
   * Formata os campos para o padrão necessário
   * 
   * @param name Nome visivel para o usuário
   * @param xml Nome do a ser buscado no Relatório
   * @param tag Tag do XML
   * 
   * campo = info -> Inforamações da Nota
   * campo = item -> Inforamações do Produto (Discrimina todos os produtos da nota)
   * 
   * @returns "{id, name, xml, checked, campo, order, tag}"
   */
  const makeInfo = (name: string, xml: string, tag = ""): NodeData => ({ id: uuidv4(), name, xml, checked: 0, campo: "info", order: order += 1, tag });
  const makeItem = (name: string, xml: string, tag = ""): NodeData => ({ id: uuidv4(), name, xml, checked: 0, campo: "item", order: order += 1, tag });

  const itens: NodeData = {
    "name": "NF-es",
    "children": [
      {
        "name": "NF-e",
        "children": [
          makeInfo("Chave", "nfe_chv", "chNFe"),
          makeInfo("Modelo", "nfe_cod_mod", "mod"),
          makeInfo("Série", "nfe_ser", "serie"),
          makeInfo("Número", "nfe_num_doc", "nNF"),
          makeInfo("Data Emissão", "nfe_dt_doc", "dhEmi"),
          makeInfo("Data de Entrada/Saída", "nfe_dt_e_s", "dhSaiEnt"),
          makeInfo("Código Estado", "nfe_cod_estado", "cUF"),
          makeInfo("Código Numérico", "nfe_cod_num", "cNF"),
          makeInfo("Natureza Operação", "nfe_nat_op", "natOp"),
          makeInfo("Processo de Emissão", "nfe_proc_emi", "procEmi"),
          makeInfo("Tipo de Emissão", "nfe_tp_emis", "tpEmis"),
          makeInfo("Tipo da Nota Fiscal", "nfe_tp_nf", "tpNF"),
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "Emitente",
        "children": [
          makeInfo("CNPJ - Emit", "nfe_emit_cnpj", "CNPJ"),
          makeInfo("Razão Social - Emit", "nfe_emit_nome", "xNome"),
          makeInfo("Nome Fantasia - Emit", "nfe_emit_fant", "xFant"),
          makeInfo("Inscrição Estadual - Emit", "nfe_emit_ie", "IE"),
          makeInfo("UF - Emit", "nfe_emit_uf", "UF"),
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "Destinatário",
        "children": [
          makeInfo("CNPJ - Dest", "nfe_dest_cnpj", "CNPJ"),
          makeInfo("Razão Social - Dest", "nfe_dest_nome", "xNome"),
          makeInfo("Inscrição Estadual - Dest", "nfe_dest_ie", "IE"),
          makeInfo("UF - Dest", "nfe_dest_uf", "UF"),
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "Valores Totais",
        "children": [
          makeInfo("BC - Total", "nfe_vl_bc_icms", "vBC"),
          makeInfo("BC ST - Total", "nfe_vl_bc_icms_st", "vBCST"),
          makeInfo("ICMS - Total", "nfe_vl_icms", "vICMS"),
          makeInfo("ICMS ST - Total", "nfe_vl_icms_st", "vICMSST"),
          makeInfo("IPI - Total", "nfe_vl_ipi", "vIPI"),
          makeInfo("Frete - Total", "nfe_vl_frt", "vFrete"),
          makeInfo("NF-E - Total", "nfe_vl_nfe", "vNF"),
          makeInfo("Produtos - Total", "nfe_vl_merc", "vNF"),
          makeInfo("Desconto - Total", "nfe_vl_desc", "vDesc"),
          makeInfo("Outras Despesas - Total", "nfe_vl_outro", "vOutro"),
          makeInfo("IPI Devolução - Total", "nfe_ipi_devol", "vIPIDevol"),
          makeInfo("PIS - Total", "nfe_vl_pis", "vPIS"),
          makeInfo("FCP - Total", "nfe_vl_fcp", "vFCP"),
          makeInfo("FCP ST - Total", "nfe_vl_fcp_st", "vFCPST"),
          makeInfo("COFINS - Total", "nfe_vl_cofins", "vCOFINS"),
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "IBS e CBS",
        "children": [
          makeInfo("IBS / CBS - Total", "nfe_base_calculo_ibs_cbs", "vBCIBSCBS"),
          makeInfo("IBS UF Diferimento - Total", "nfe_ibs_uf_diferimento", "vDif"),
          makeInfo("IBS UF Devolução Tributos - Total", "nfe_ibs_uf_devolucao_tributos", "vDevTrib"),
          makeInfo("IBS UF - Total", "nfe_ibs_uf_valor_total", "vIBSUF"),
          makeInfo("IBS Município Diferimento - Total", "nfe_ibs_municipio_diferimento", "vDif"),
          makeInfo("IBS Município Devolução Tributos - Total", "nfe_ibs_municipio_devolucao_tributos", "vDevTrib"),
          makeInfo("IBS Município - Total", "nfe_ibs_municipio_valor_total", "vIBSMun"),
          makeInfo("IBS - Total", "nfe_ibs_valor_total", "vIBS"),
          makeInfo("IBS Crédito Presumido - Total", "nfe_ibs_credito_presumido", "vCredPres"),
          makeInfo("IBS Crédito Presumido (Cond. Susp.) - Total", "nfe_ibs_credito_presumido_suspenso", "vCredPresCondSus"),
          makeInfo("CBS Diferimento - Total", "nfe_cbs_diferimento", "vDif"),
          makeInfo("CBS Devolução Tributos - Total", "nfe_cbs_devolucao_tributos", "vDevTrib"),
          makeInfo("CBS - Total", "nfe_cbs_valor_total", "vCBS"),
          makeInfo("CBS Crédito Presumido - Total", "nfe_cbs_credito_presumido", "vCredPres"),
          makeInfo("CBS Crédito Presumido (Cond. Susp.) - Total", "nfe_cbs_credito_presumido_suspenso", "vCredPresCondSus"),
          makeInfo("IBS Monofásico - Total", "nfe_ibs_monofasico_valor_total", "vIBSMono"),
          makeInfo("CBS Monofásico - Total", "nfe_cbs_monofasico_valor_total", "vCBSMono"),
          makeInfo("IBS Monofásico Retenção - Total", "nfe_ibs_monofasico_retencao", "vIBSMonoReten"),
          makeInfo("CBS Monofásico Retenção - Total", "nfe_cbs_monofasico_retencao", "vCBSMonoReten"),
          makeInfo("IBS Monofásico Retido - Total", "nfe_ibs_monofasico_retido", "vIBSMonoRet"),
          makeInfo("CBS Monofásico Retido - Total", "nfe_cbs_monofasico_retido", "vCBSMonoRet"),
          makeInfo("IBS Estorno de Crédito - Total", "nfe_ibs_estorno_credito", "vIBSEstCred"),
          makeInfo("CBS Estorno de Crédito - Total", "nfe_cbs_estorno_credito", "vCBSEstCred"),
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "Transportador",
        "children": [
          makeInfo("CNPJ - Transp", "nfe_transp_cnpj", "CNPJ"),
          makeInfo("Razão Social - Transp", "nfe_transp_nome", "xNome"),
          makeInfo("Inscrição Estadual - Transp", "nfe_transp_ie", "IE"),
          makeInfo("Município - Transp", "nfe_transp_mun", "xMun"),
          makeInfo("UF - Transp", "nfe_transp_uf", "UF"),
          makeInfo("Volume - Transp", "nfe_transp_vol", "qVol"),
          makeInfo("Espécie - Transp", "nfe_transp_esp", "esp"),
          makeInfo("Peso Líquido - Transp", "nfe_transp_pesol", "pesoL"),
          makeInfo("Peso Bruto - Transp", "nfe_transp_pesob", "pesoB"),
          makeInfo("Veiculo Placa - Transp", "nfe_transp_veiculo_placa", "placa"),
          makeInfo("Veiculo UF - Transp", "nfe_transp_veiculo_uf", "UF"),
          makeInfo("Veiculo RNTC - Transp", "nfe_transp_veiculo_rntc", "RNTC"),
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "Produtos",
        "children": [
          makeItem("Código - Produto", "prod_cod", "cProd"),
          makeItem("EAN - Produto", "prod_ean", "cEAN"),
          makeItem("Nome - Produto", "prod_nome", "xProd"),
          makeItem("Número - Produto", "prod_numero", "nItem"),
          makeItem("NCM - Produto", "prod_ncm", "NCM"),
          makeItem("CEST - Produto", "prod_cest", "CEST"),
          makeItem("CFOP - Produto", "prod_cfop", "CFOP"),
          makeItem("Valor - Produto", "prod_vl_opr", "vProd"),
          makeItem("EAN Tribu. - Produto", "prod_ean_trib", "cEANTrib"),
          makeItem("Desconto - Produto", "prod_desc", "vDesc"),
          makeItem("Unidade - Produto", "prod_un", "uCom"),
          makeItem("Quantidade - Produto", "prod_quanti", "qCom"),
          makeItem("Valor Unitário - Produto", "prod_unit", "vUnCom"),
          makeItem("Unidade Tribu. - Produto", "prod_un_trib", "uTrib"),
          makeItem("Quantidade Tribu. - Produto", "prod_quanti_trib", "qTrib"),
          makeItem("Valor Unitário Tribu. - Produto", "prod_unit_trib", "vUnTrib"),
          makeItem("IPI CST - Produto", "prod_cst_ipi", "pIPI"),
          makeItem("IPI BC - Produto", "prod_vl_bc_ipi", "vBC"),
          makeItem("PIS CST - Produto", "prod_cst_pis", "CST"),
          makeItem("PIS BC - Produto", "prod_vl_bc_pis", "vBC"),
          makeItem("COFINS CST - Produto", "prod_cst_cofins", "CST"),
          makeItem("COFINS BC - Produto", "prod_vl_bc_cofins", "vBC"),
          makeItem("ICMS CST - Produto", "prod_cst_icms", "CST"),
          makeItem("ICMS BC - Produto", "prod_vl_bc_icms", "vBC"),
          makeItem("ICMS BCST - Produto", "prod_vl_bc_icms_st", "vBCST"),
          makeItem("ICMS - Produto", "prod_vl_icms", "vICMS"),
          makeItem("Aliq. ICMS - Produto", "prod_aliq_icms", "pICMS"),
          makeItem("MVA ST - Produto", "prod_vl_mva_st", "pMVAST"),
          makeItem("ICMS ST - Produto", "prod_vl_icms_st", "vICMSST"),
          makeItem("Aliq. ICMS ST - Produto", "prod_aliq_icms_st", "pICMSST"),
          makeItem("IPI - Produto", "prod_vl_ipi", "vIPI"),
          makeItem("Aliq. IPI - Produto", "prod_aliq_ipi", "pIPI"),
          makeItem("PIS - Produto", "prod_vl_pis", "vPIS"),
          makeItem("COFINS - Produto", "prod_vl_cofins", "vCOFINS"),
          makeItem("Outras Despesas - Produto", "prod_vl_outro", "vOutro"),
          makeItem("IBS/CBS CST - Produto", "prod_ibs_cbs_cst", "CST"),
          makeItem("IBS/CBS Class. Tributária - Produto", "prod_ibs_cbs_class_tributaria", "cClassTrib"),
          makeItem("IBS/CBS Base Cálculo - Produto", "prod_ibs_cbs_base_calculo", "vBC"),
          makeItem("IBS UF Alíquota - Produto", "prod_ibs_uf_aliquota", "pIBSUF"),
          makeItem("IBS UF Redução Alíquota - Produto", "prod_ibs_uf_reducao_aliquota", "pRedAliq"),
          makeItem("IBS UF Alíquota Efetiva - Produto", "prod_ibs_uf_aliquota_efetiva", "pAliqEfet"),
          makeItem("IBS UF Valor - Produto", "prod_ibs_uf_valor", "vIBSUF"),
          makeItem("IBS Município Alíquota - Produto", "prod_ibs_municipio_aliquota", "pIBSMun"),
          makeItem("IBS Município Redução Alíquota - Produto", "prod_ibs_municipio_reducao_aliquota", "pRedAliq"),
          makeItem("IBS Município Alíquota Efetiva - Produto", "prod_ibs_municipio_aliquota_efetiva", "pAliqEfet"),
          makeItem("IBS Município Valor - Produto", "prod_ibs_municipio_valor", "vIBSMun"),
          makeItem("IBS Valor Total - Produto", "prod_ibs_valor_total", "vIBS"),
          makeItem("CBS Alíquota - Produto", "prod_cbs_aliquota", "pCBS"),
          makeItem("CBS Valor - Produto", "prod_cbs_valor", "vCBS"),
          makeItem("CBS Redução Alíquota - Produto", "prod_cbs_reducao_aliquota", "pRedAliq"),
          makeItem("CBS Alíquota Efetiva - Produto", "prod_cbs_aliquota_efetiva", "pAliqEfet"),
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "Cálculos",
        "children": [
          makeItem("Nome - Cálculo", "calc_nome", "nome"),
          makeItem("Valido de - Cálculo", "calc_valido_de", "valido_de"),
          makeItem("Valido até - Cálculo", "calc_valido_ate", "valido_ate"),
          makeItem("ICMS - Cálculo", "calc_icms", "icms"),
          makeItem("Class. Nome - Cálculo", "calc_classi_nome", "nome"),
          makeItem("Class. Código Receita - Cálculo", "calc_classi_cod", "codigo_receita"),
          makeItem("MVA - Cálculo", "calc_mva", "mva"),
          makeItem("Valor FCP calculado - Cálculo", "calc_fcp", "valor_fcp"),
          makeItem("Valor ICM calculado - Cálculo", "calc_icms_ant", "valor_icms_ant"),
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "Observações",
        "children": [
          makeInfo("Fisico - Info", "nfe_inf_fisico", "infAdFisco"),
          makeInfo("CPL - Info", "nfe_inf_cpl", "infCpl"),
          makeInfo("Resp. CNPJ - Info", "nfe_inf_resp_cnpj", "CNPJ"),
          makeInfo("Resp. Contato - Info", "nfe_inf_resp_contato", "xContato"),
          makeInfo("Resp. Email - Info", "nfe_inf_resp_email", "email"),
          makeInfo("Resp. Fone - Info", "nfe_inf_resp_fone", "fone"),
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      }
    ],
    "_id": uuidv4(),
    checked: 0,
    isOpen: true
  }

  return itens

}

export const sorted_tags_nfes = [
  { id: uuidv4(), name: "Chave", xml: "nfe_chv", tag: "NF-e", value: "string" },
  { id: uuidv4(), name: "Modelo", xml: "nfe_cod_mod", tag: "NF-e", value: "string" },
  { id: uuidv4(), name: "Série", xml: "nfe_ser", tag: "NF-e", value: "string" },
  { id: uuidv4(), name: "Número", xml: "nfe_num_doc", tag: "NF-e", value: "string" },
  { id: uuidv4(), name: "Data Emissão", xml: "nfe_dt_doc", tag: "NF-e", value: "data" },
  { id: uuidv4(), name: "Data de Entrada/Saída", xml: "nfe_dt_e_s", tag: "NF-e", value: "data" },
  { id: uuidv4(), name: "Código Estado", xml: "nfe_cod_estado", tag: "NF-e", value: "string" },
  { id: uuidv4(), name: "Código Numérico", xml: "nfe_cod_num", tag: "NF-e", value: "string" },
  { id: uuidv4(), name: "Natureza Operação", xml: "nfe_nat_op", tag: "NF-e", value: "string" },
  { id: uuidv4(), name: "Processo de Emissão", xml: "nfe_proc_emi", tag: "NF-e", value: "string" },
  { id: uuidv4(), name: "Tipo de Emissão", xml: "nfe_tp_emis", tag: "NF-e", value: "string" },
  { id: uuidv4(), name: "Tipo da Nota Fiscal", xml: "nfe_tp_nf", tag: "NF-e", value: "string" },
  { id: uuidv4(), name: "CNPJ - Emit", xml: "nfe_emit_cnpj", tag: "Emitente", value: "string" },
  { id: uuidv4(), name: "Razão Social - Emit", xml: "nfe_emit_nome", tag: "Emitente", value: "string" },
  { id: uuidv4(), name: "Nome Fantasia - Emit", xml: "nfe_emit_fant", tag: "Emitente", value: "string" },
  { id: uuidv4(), name: "Inscrição Estadual - Emit", xml: "nfe_emit_ie", tag: "Emitente", value: "string" },
  { id: uuidv4(), name: "UF - Emit", xml: "nfe_emit_uf", tag: "Emitente", value: "string" },
  { id: uuidv4(), name: "CNPJ - Dest", xml: "nfe_dest_cnpj", tag: "Destinatário", value: "string" },
  { id: uuidv4(), name: "Razão Social - Dest", xml: "nfe_dest_nome", tag: "Destinatário", value: "string" },
  { id: uuidv4(), name: "Inscrição Estadual - Dest", xml: "nfe_dest_ie", tag: "Destinatário", value: "string" },
  { id: uuidv4(), name: "UF - Dest", xml: "nfe_dest_uf", tag: "Destinatário", value: "string" },
  { id: uuidv4(), name: "BC - Total", xml: "nfe_vl_bc_icms", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "BC ST - Total", xml: "nfe_vl_bc_icms_st", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "ICMS - Total", xml: "nfe_vl_icms", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "ICMS ST - Total", xml: "nfe_vl_icms_st", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "IPI - Total", xml: "nfe_vl_ipi", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "Frete - Total", xml: "nfe_vl_frt", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "NFE - Total", xml: "nfe_vl_nfe", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "Produto - Total", xml: "nfe_vl_merc", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "Desconto - Total", xml: "nfe_vl_desc", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "Outras Despesas - Total", xml: "nfe_vl_outro", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "IPI Devolução - Total", xml: "nfe_ipi_devol", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "PIS - Total", xml: "nfe_vl_pis", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "FCP - Total", xml: "nfe_vl_fcp", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "FCP ST - Total", xml: "nfe_vl_fcp_st", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "COFINS - Total", xml: "nfe_vl_cofins", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "IBS / CBS - Total", xml: "nfe_base_calculo_ibs_cbs", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "IBS UF Diferimento - Total", xml: "nfe_ibs_uf_diferimento", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "IBS UF Devolução Tributos - Total", xml: "nfe_ibs_uf_devolucao_tributos", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "IBS UF - Total", xml: "nfe_ibs_uf_valor_total", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "IBS Município Diferimento - Total", xml: "nfe_ibs_municipio_diferimento", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "IBS Município Devolução Tributos - Total", xml: "nfe_ibs_municipio_devolucao_tributos", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "IBS Município - Total", xml: "nfe_ibs_municipio_valor_total", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "IBS - Total", xml: "nfe_ibs_valor_total", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "IBS Crédito Presumido - Total", xml: "nfe_ibs_credito_presumido", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "IBS Crédito Presumido (Cond. Susp.) - Total", xml: "nfe_ibs_credito_presumido_suspenso", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "CBS Diferimento - Total", xml: "nfe_cbs_diferimento", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "CBS Devolução Tributos - Total", xml: "nfe_cbs_devolucao_tributos", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "CBS - Total", xml: "nfe_cbs_valor_total", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "CBS Crédito Presumido - Total", xml: "nfe_cbs_credito_presumido", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "CBS Crédito Presumido (Cond. Susp.) - Total", xml: "nfe_cbs_credito_presumido_suspenso", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "IBS Monofásico - Total", xml: "nfe_ibs_monofasico_valor_total", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "CBS Monofásico - Total", xml: "nfe_cbs_monofasico_valor_total", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "IBS Monofásico Retenção - Total", xml: "nfe_ibs_monofasico_retencao", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "CBS Monofásico Retenção - Total", xml: "nfe_cbs_monofasico_retencao", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "IBS Monofásico Retido - Total", xml: "nfe_ibs_monofasico_retido", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "CBS Monofásico Retido - Total", xml: "nfe_cbs_monofasico_retido", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "IBS Estorno de Crédito - Total", xml: "nfe_ibs_estorno_credito", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "CBS Estorno de Crédito - Total", xml: "nfe_cbs_estorno_credito", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "CNPJ - Transp", xml: "nfe_transp_cnpj", tag: "Transportador", value: "string" },
  { id: uuidv4(), name: "Razão Social - Transp", xml: "nfe_transp_nome", tag: "Transportador", value: "string" },
  { id: uuidv4(), name: "Inscrição Estadual - Transp", xml: "nfe_transp_ie", tag: "Transportador", value: "string" },
  { id: uuidv4(), name: "Município - Transp", xml: "nfe_transp_mun", tag: "Transportador", value: "string" },
  { id: uuidv4(), name: "UF - Transp", xml: "nfe_transp_uf", tag: "Transportador", value: "string" },
  { id: uuidv4(), name: "Volume - Transp", xml: "nfe_transp_vol", tag: "Transportador", value: "string" },
  { id: uuidv4(), name: "Espécie - Transp", xml: "nfe_transp_esp", tag: "Transportador", value: "string" },
  { id: uuidv4(), name: "Peso Líquido - Transp", xml: "nfe_transp_pesol", tag: "Transportador", value: "number" },
  { id: uuidv4(), name: "Peso Bruto - Transp", xml: "nfe_transp_pesob", tag: "Transportador", value: "number" },
  { id: uuidv4(), name: "Veiculo Placa - Transp", xml: "nfe_transp_veiculo_placa", tag: "Transportador", value: "string", },
  { id: uuidv4(), name: "Veiculo UF - Transp", xml: "nfe_transp_veiculo_uf", tag: "Transportador", value: "string", },
  { id: uuidv4(), name: "Veiculo RNTC - Transp", xml: "nfe_transp_veiculo_rntc", tag: "Transportador", value: "string", },
  { id: uuidv4(), name: "Código - Produto", xml: "prod_cod", tag: "Produtos", value: "string" },
  { id: uuidv4(), name: "EAN - Produto", xml: "prod_ean", tag: "Produtos", value: "string" },
  { id: uuidv4(), name: "Nome - Produto", xml: "prod_nome", tag: "Produtos", value: "string" },
  { id: uuidv4(), name: "Número - Produto", xml: "prod_numero", tag: "Produtos", value: "string" },
  { id: uuidv4(), name: "NCM - Produto", xml: "prod_ncm", tag: "Produtos", value: "string" },
  { id: uuidv4(), name: "CEST - Produto", xml: "prod_cest", tag: "Produtos", value: "string" },
  { id: uuidv4(), name: "CFOP - Produto", xml: "prod_cfop", tag: "Produtos", value: "string" },
  { id: uuidv4(), name: "Valor - Produto", xml: "prod_vl_opr", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "EAN Tribu. - Produto", xml: "prod_ean_trib", tag: "Produtos", value: "string" },
  { id: uuidv4(), name: "Desconto - Produto", xml: "prod_desc", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "Unidade - Produto", xml: "prod_un", tag: "Produtos", value: "string" },
  { id: uuidv4(), name: "Quantidade - Produto", xml: "prod_quanti", tag: "Produtos", value: "string" },
  { id: uuidv4(), name: "Valor Unitário - Produto", xml: "prod_unit", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "Unidade Tribu. - Produto", xml: "prod_un_trib", tag: "Produtos", value: "string" },
  { id: uuidv4(), name: "Quantidade Tribu. - Produto", xml: "prod_quanti_trib", tag: "Produtos", value: "string" },
  { id: uuidv4(), name: "Valor Unitário Tribu. - Produto", xml: "prod_unit_trib", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "IPI CST - Produto", xml: "prod_cst_ipi", tag: "Produtos", value: "string" },
  { id: uuidv4(), name: "IPI BC - Produto", xml: "prod_vl_bc_ipi", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "PIS CST - Produto", xml: "prod_cst_pis", tag: "Produtos", value: "string" },
  { id: uuidv4(), name: "PIS BC - Produto", xml: "prod_vl_bc_pis", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "COFINS CST - Produto", xml: "prod_cst_cofins", tag: "Produtos", value: "string" },
  { id: uuidv4(), name: "COFINS BC - Produto", xml: "prod_vl_bc_cofins", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "ICMS CST - Produto", xml: "prod_cst_icms", tag: "Produtos", value: "string" },
  { id: uuidv4(), name: "ICMS BC - Produto", xml: "prod_vl_bc_icms", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "ICMS BC ST - Produto", xml: "prod_vl_bc_icms_st", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "ICMS - Produto", xml: "prod_vl_icms", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "Aliq. ICMS - Produto", xml: "prod_aliq_icms", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "MVA ST - Produto", xml: "prod_vl_mva_st", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "ICMS ST - Produto", xml: "prod_vl_icms_st", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "Aliq. ICMS ST - Produto", xml: "prod_aliq_icms_st", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "IPI - Produto", xml: "prod_vl_ipi", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "Aliq. IPI - Produto", xml: "prod_aliq_ipi", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "PIS - Produto", xml: "prod_vl_pis", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "COFINS - Produto", xml: "prod_vl_cofins", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "Outras Despesas - Produto", xml: "prod_vl_outro", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "IBS/CBS CST - Produto", xml: "prod_ibs_cbs_cst", tag: "Produtos", value: "string" },
  { id: uuidv4(), name: "IBS/CBS Class. Tributária - Produto", xml: "prod_ibs_cbs_class_tributaria", tag: "Produtos", value: "string" },
  { id: uuidv4(), name: "IBS/CBS Base Cálculo - Produto", xml: "prod_ibs_cbs_base_calculo", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "IBS UF Alíquota - Produto", xml: "prod_ibs_uf_aliquota", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "IBS UF Redução Alíquota - Produto", xml: "prod_ibs_uf_reducao_aliquota", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "IBS UF Alíquota Efetiva - Produto", xml: "prod_ibs_uf_aliquota_efetiva", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "IBS UF Valor - Produto", xml: "prod_ibs_uf_valor", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "IBS Município Alíquota - Produto", xml: "prod_ibs_municipio_aliquota", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "IBS Município Redução Alíquota - Produto", xml: "prod_ibs_municipio_reducao_aliquota", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "IBS Município Alíquota Efetiva - Produto", xml: "prod_ibs_municipio_aliquota_efetiva", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "IBS Município Valor - Produto", xml: "prod_ibs_municipio_valor", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "IBS Valor Total - Produto", xml: "prod_ibs_valor_total", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "CBS Alíquota - Produto", xml: "prod_cbs_aliquota", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "CBS Valor - Produto", xml: "prod_cbs_valor", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "CBS Redução Alíquota - Produto", xml: "prod_cbs_reducao_aliquota", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "CBS Alíquota Efetiva - Produto", xml: "prod_cbs_aliquota_efetiva", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "Nome - Cálculo", xml: "calc_nome", tag: "Produtos", value: "calculo" },
  { id: uuidv4(), name: "Valido de - Cálculo", xml: "calc_valido_de", tag: "Produtos", value: "data" },
  { id: uuidv4(), name: "Valido até - Cálculo", xml: "calc_valido_ate", tag: "Produtos", value: "data" },
  { id: uuidv4(), name: "ICMS - Cálculo", xml: "calc_icms", tag: "Produtos", value: "boolean" },
  { id: uuidv4(), name: "Class. Nome - Cálculo", xml: "calc_classi_nome", tag: "Produtos", value: "classificacao" },
  { id: uuidv4(), name: "Class. Código Receita - Cálculo", xml: "calc_classi_cod", tag: "Produtos", value: "string" },
  { id: uuidv4(), name: "MVA - Cálculo", xml: "calc_mva", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "Valor FCP calculado - Cálculo", xml: "calc_fcp", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "Valor ICM calculado - Cálculo", xml: "calc_icms_ant", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "Fisico - Info", xml: "nfe_inf_fisico", tag: "NFE-e", value: "string" },
  { id: uuidv4(), name: "CPL - Info", xml: "nfe_inf_cpl", tag: "NFE-e", value: "string" },
  { id: uuidv4(), name: "Resp. CNPJ - Info", xml: "nfe_inf_resp_cnpj", tag: "NFE-e", value: "string" },
  { id: uuidv4(), name: "Resp. Contato - Info", xml: "nfe_inf_resp_contato", tag: "NFE-e", value: "string" },
  { id: uuidv4(), name: "Resp. Email - Info", xml: "nfe_inf_resp_email", tag: "NFE-e", value: "string" },
  { id: uuidv4(), name: "Resp. Fone - Info", xml: "nfe_inf_resp_fone", tag: "NFE-e", value: "string" }
]

export function values_cte() {

  let order = 0

  /**
   * Formata os campos para o padrão necessário
   * 
   * @param name Nome visivel para o usuário
   * @param xml Nome do a ser buscado no Relatório
   * @param tag Tag do XML
   * 
   * campo = info -> Inforamações da Nota
   * campo = item -> Inforamações do Produto (Discrimina todos os produtos da nota)
   * 
   * @returns "{id, name, xml, checked, campo, order, tag}"
   */
  const makeInfo = (name: string, xml: string, tag = ""): NodeData => ({ id: uuidv4(), name, xml, checked: 0, campo: "info", order: order += 1, tag });
  const makeItem = (name: string, xml: string, tag = ""): NodeData => ({ id: uuidv4(), name, xml, checked: 0, campo: "item", order: order += 1, tag });

  let itens: NodeData = {
    "name": "CT-es",
    "children": [
      {
        "name": "CT-e",
        "children": [
          makeInfo("Chave", "cte_chv", "chCTe"),
          makeInfo("Número", "cte_num_doc", "nCT"),
          makeInfo("Código UF", "cte_cod_uf", "cUF"),
          makeInfo("Código Modelo", "cte_cod_mod", "mod"),
          makeInfo("CFOP", "cte_cfop", "CFOP"),
          makeInfo("Série", "cte_ser", "serie"),
          makeInfo("Data Emissão", "cte_data_emi", "dhEmi"),
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "Emitente",
        "children": [
          makeInfo("CNPJ - Emit", "cte_emit_cnpj", "CNPJ"),
          makeInfo("Razão Social - Emit", "cte_emit_nome", "xNome"),
          makeInfo("Nome Fantasia - Emit", "cte_emit_fant", "xFant"),
          makeInfo("Inscrição Estadual - Emit", "cte_emit_ie", "IE"),
          makeInfo("UF - Emit", "cte_emit_uf", "UF"),
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "Remetente",
        "children": [
          makeInfo("CNPJ - Remet", "cte_rem_cnpj", "CNPJ"),
          makeInfo("Razão Social - Remet", "cte_rem_nome", "xNome"),
          makeInfo("Inscrição Estadual - Remet", "cte_rem_ie", "IE"),
          makeInfo("Estado - Remet", "cte_rem_uf", "UF"),
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "Destinatário",
        "children": [
          makeInfo("CNPJ - Dest", "cte_dest_cnpj", "CNPJ"),
          makeInfo("Razão Social - Dest", "cte_dest_nome", "xNome"),
          makeInfo("Inscrição Estadual - Dest", "cte_dest_ie", "IE"),
          makeInfo("Estado - Dest", "cte_dest_uf", "UF"),
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "Valores Totais",
        "children": [
          makeInfo("ICMS - Total", "cte_vl_icms", "vICMS"),
          makeInfo("ICMS CST - Total", "cte_cst_icms", "CST"),
          makeInfo("BC - Total", "cte_vl_bc_icms", "vBC"),
          makeInfo("CTE - Total", "cte_vl_doc", "vTPrest"),
          makeInfo("Valor Total Tributos - Total", "cte_valor_total_tributos", "vTotTrib"),
          makeInfo("Valor Total do Documento - Total", "cte_valor_total_documento", "vTotDFe")
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "IBS e CBS",
        "children": [
          makeInfo("IBS/CBS CST - Total", "cte_ibs_cbs_cst", "CST"),
          makeInfo("IBS/CBS Class. Tributária - Total - Total", "cte_ibs_cbs_class_tributaria", "cClassTrib"),
          makeInfo("IBS/CBS Base Cálculo - Total", "cte_ibs_cbs_base_calculo", "vBC"),
          makeInfo("IBS UF Percentual - Total", "cte_ibs_uf_percetual", "pIBSUF"),
          makeInfo("IBS UF Valor - Total", "cte_ibs_uf_valor", "vIBSUF"),
          makeInfo("IBS Mun Percentual - Total", "cte_ibs_mun_percetual", "pIBSMun"),
          makeInfo("IBS Mun Valor - Total", "cte_ibs_mun_valor", "vIBSMun"),
          makeInfo("IBS Valor Total - Total", "cte_valor_ibs", "vIBS"),
          makeInfo("CBS UF Percentual - Total", "cte_cbs_percetual", "pCBS"),
          makeInfo("CBS UF Val - Total", "cte_cbs_valor", "vCBS")
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "Cálculos",
        "children": [
          makeItem("Nome - Cálculo", "calc_nome", "nome"),
          makeItem("Valido de - Cálculo", "calc_valido_de", "valido_de"),
          makeItem("Valido até - Cálculo", "calc_valido_ate", "valido_ate"),
          makeItem("ICMS - Cálculo", "calc_icms", "icms"),
          makeItem("Class. Nome - Cálculo", "calc_classi_nome", "nome"),
          makeItem("Class. Código Receita - Cálculo", "calc_classi_cod", "codigo_receita"),
          makeItem("MVA - Cálculo", "calc_mva", "mva"),
          makeItem("Valor FCP calculado - Cálculo", "calc_fcp", "valor_fcp"),
          makeItem("Valor ICM calculado - Cálculo", "calc_icms_ant", "valor_icms_ant"),
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "Observações",
        "children": [
          makeInfo("Resp. CNPJ - Info", "cte_inf_resp_cnpj", "CNPJ"),
          makeInfo("Resp. Contato - Info", "cte_inf_resp_contato", "xContato"),
          makeInfo("Resp. Email - Info", "cte_inf_resp_email", "email"),
          makeInfo("Resp. Fone - Info", "cte_inf_resp_fone", "fone"),
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      }
    ],
    "_id": uuidv4(),
    checked: 0,
    isOpen: true
  }

  return itens

}

export const sorted_tags_ctes = [
  { id: uuidv4(), name: "Chave", xml: "cte_chv", tag: "CT-e", value: "string" },
  { id: uuidv4(), name: "Número", xml: "cte_num_doc", tag: "CTE-e", value: "string" },
  { id: uuidv4(), name: "Código UF", xml: "cte_cod_uf", tag: "CT-e", value: "string" },
  { id: uuidv4(), name: "Código Modelo", xml: "cte_cod_mod", tag: "CT-e", value: "string" },
  { id: uuidv4(), name: "CFOP", xml: "cte_cfop", tag: "CT-e", value: "string" },
  { id: uuidv4(), name: "Série", xml: "cte_ser", tag: "CT-e", value: "string" },
  { id: uuidv4(), name: "Data Emissão", xml: "cte_data_emi", tag: "CT-e", value: "data" },
  { id: uuidv4(), name: "CNPJ - Emit", xml: "cte_emit_cnpj", tag: "Emitente", value: "string" },
  { id: uuidv4(), name: "Razão Social - Emit", xml: "cte_emit_nome", tag: "Emitente", value: "string" },
  { id: uuidv4(), name: "Nome Fantasia - Emit", xml: "cte_emit_fant", tag: "Emitente", value: "string" },
  { id: uuidv4(), name: "Inscrição Estadual - Emit", xml: "cte_emit_ie", tag: "Emitente", value: "string" },
  { id: uuidv4(), name: "UF - Emit", xml: "cte_emit_uf", tag: "Emitente", value: "string" },
  { id: uuidv4(), name: "CNPJ - Remet", xml: "cte_rem_cnpj", tag: "Remetente", value: "string" },
  { id: uuidv4(), name: "Razão Social - Remet", xml: "cte_rem_nome", tag: "Remetente", value: "string" },
  { id: uuidv4(), name: "Inscrição Estadual - Remet", xml: "cte_rem_ie", tag: "Remetente", value: "string" },
  { id: uuidv4(), name: "Estado - Remet", xml: "cte_rem_ie", tag: "Remetente", value: "string" },
  { id: uuidv4(), name: "CNPJ - Dest", xml: "cte_dest_cnpj", tag: "Destinatário", value: "string" },
  { id: uuidv4(), name: "Razão Social - Dest", xml: "cte_dest_nome", tag: "Destinatário", value: "string" },
  { id: uuidv4(), name: "Inscrição Estadual - Dest", xml: "cte_dest_ie", tag: "Destinatário", value: "string" },
  { id: uuidv4(), name: "Estado - Dest", xml: "cte_dest_uf", tag: "Destinatário", value: "string" },
  { id: uuidv4(), name: "ICMS - Total", xml: "cte_vl_icms", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "ICMS CST - Total", xml: "cte_cst_icms", tag: "Valores Totais", value: "string" },
  { id: uuidv4(), name: "BC - Total", xml: "cte_vl_bc_icms", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "CTE - Total", xml: "cte_vl_doc", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "Valor Total Tributos - Total", xml: "cte_valor_total_tributos", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "Valor Total do Documento - Total", xml: "cte_valor_total_documento", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "IBS/CBS CST - Total", xml: "cte_ibs_cbs_cst", tag: "Valores Totais", value: "string" },
  { id: uuidv4(), name: "IBS/CBS Class. Tributária - Total - Total", xml: "cte_ibs_cbs_class_tributaria", tag: "Valores Totais", value: "string" },
  { id: uuidv4(), name: "IBS/CBS Base Cálculo - Total", xml: "cte_ibs_cbs_base_calculo", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "IBS UF Percentual - Total", xml: "cte_ibs_uf_percetual", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "IBS UF Valor - Total", xml: "cte_ibs_uf_valor", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "IBS Mun Percentual - Total", xml: "cte_ibs_mun_percetual", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "IBS Mun Valor - Total", xml: "cte_ibs_mun_valor", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "IBS Valor Total - Total", xml: "cte_valor_ibs", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "CBS UF Percentual - Total", xml: "cte_cbs_percetual", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "CBS UF Val - Total", xml: "cte_cbs_valor", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "Nome - Cálculo", xml: "calc_nome", tag: "Produtos", value: "calculo" },
  { id: uuidv4(), name: "Valido de - Cálculo", xml: "calc_valido_de", tag: "Produtos", value: "data" },
  { id: uuidv4(), name: "Valido até - Cálculo", xml: "calc_valido_ate", tag: "Produtos", value: "data" },
  { id: uuidv4(), name: "ICMS - Cálculo", xml: "calc_icms", tag: "Produtos", value: "boolean" },
  { id: uuidv4(), name: "Class. Nome - Cálculo", xml: "calc_classi_nome", tag: "Produtos", value: "classificacao" },
  { id: uuidv4(), name: "Class. Código Receita - Cálculo", xml: "calc_classi_cod", tag: "Produtos", value: "string" },
  { id: uuidv4(), name: "MVA - Cálculo", xml: "calc_mva", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "Valor FCP calculado - Cálculo", xml: "calc_fcp", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "Valor ICM calculado - Cálculo", xml: "calc_icms_ant", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "Resp. CNPJ - Info", xml: "cte_inf_resp_cnpj", tag: "CT-e", value: "string" },
  { id: uuidv4(), name: "Resp. Contato - Info", xml: "cte_inf_resp_contato", tag: "CT-e", value: "string" },
  { id: uuidv4(), name: "Resp. Email - Info", xml: "cte_inf_resp_email", tag: "CT-e", value: "string" },
  { id: uuidv4(), name: "Resp. Fone - Info", xml: "cte_inf_resp_fone", tag: "CT-e", value: "string" }
]

export function values_nfce() {

  let order = 0

  /**
   * Formata os campos para o padrão necessário
   * 
   * @param name Nome visivel para o usuário
   * @param xml Nome do a ser buscado no Relatório
   * @param tag Tag do XML
   * 
   * campo = info -> Inforamações da Nota
   * campo = item -> Inforamações do Produto (Discrimina todos os produtos da nota)
   * 
   * @returns "{id, name, xml, checked, campo, order, tag}"
   */
  const makeInfo = (name: string, xml: string, tag = ""): NodeData => ({ id: uuidv4(), name, xml, checked: 0, campo: "info", order: order += 1, tag });
  const makeItem = (name: string, xml: string, tag = ""): NodeData => ({ id: uuidv4(), name, xml, checked: 0, campo: "item", order: order += 1, tag });

  const itens: NodeData = {
    "name": "NFC-es",
    "children": [
      {
        "name": "NFC-e",
        "children": [
          makeInfo("Chave", "nfe_chv", "chNFe"),
          makeInfo("Modelo", "nfe_cod_mod", "mod"),
          makeInfo("Série", "nfe_ser", "serie"),
          makeInfo("Número", "nfe_num_doc", "nNF"),
          makeInfo("Data Emissão", "nfe_dt_doc", "dhEmi"),
          makeInfo("Data de Entrada/Saída", "nfe_dt_e_s", "dhSaiEnt"),
          makeInfo("Código Estado", "nfe_cod_estado", "cUF"),
          makeInfo("Código Numérico", "nfe_cod_num", "cNF"),
          makeInfo("Natureza Operação", "nfe_nat_op", "natOp"),
          makeInfo("Processo de Emissão", "nfe_proc_emi", "procEmi"),
          makeInfo("Tipo de Emissão", "nfe_tp_emis", "tpEmis"),
          makeInfo("Tipo da Nota Fiscal", "nfe_tp_nf", "tpNF"),
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "Emitente",
        "children": [
          makeInfo("CNPJ - Emit", "nfe_emit_cnpj", "CNPJ"),
          makeInfo("Razão Social - Emit", "nfe_emit_nome", "xNome"),
          makeInfo("Nome Fantasia - Emit", "nfe_emit_fant", "xFant"),
          makeInfo("Inscrição Estadual - Emit", "nfe_emit_ie", "IE"),
          makeInfo("UF - Emit", "nfe_emit_uf", "UF"),
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "Destinatário",
        "children": [
          makeInfo("CNPJ - Dest", "nfe_dest_cnpj", "CNPJ"),
          makeInfo("Razão Social - Dest", "nfe_dest_nome", "xNome"),
          makeInfo("Inscrição Estadual - Dest", "nfe_dest_ie", "IE"),
          makeInfo("UF - Dest", "nfe_dest_uf", "UF"),
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "Valores Totais",
        "children": [
          makeInfo("BC - Total", "nfe_vl_bc_icms", "vBC"),
          makeInfo("BC ST - Total", "nfe_vl_bc_icms_st", "vBCST"),
          makeInfo("ICMS - Total", "nfe_vl_icms", "vICMS"),
          makeInfo("ICMS ST - Total", "nfe_vl_icms_st", "vICMSST"),
          makeInfo("IPI - Total", "nfe_vl_ipi", "vIPI"),
          makeInfo("Frete - Total", "nfe_vl_frt", "vFrete"),
          makeInfo("NFC-E - Total", "nfe_vl_nfe", "vNF"),
          makeInfo("Produtos - Total", "nfe_vl_merc", "vNF"),
          makeInfo("Desconto - Total", "nfe_vl_desc", "vDesc"),
          makeInfo("Outras Despesas - Total", "nfe_vl_outro", "vOutro"),
          makeInfo("IPI Devolução - Total", "nfe_ipi_devol", "vIPIDevol"),
          makeInfo("PIS - Total", "nfe_vl_pis", "vPIS"),
          makeInfo("FCP - Total", "nfe_vl_fcp", "vFCP"),
          makeInfo("FCP ST - Total", "nfe_vl_fcp_st", "vFCPST"),
          makeInfo("COFINS - Total", "nfe_vl_cofins", "vCOFINS"),
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "IBS e CBS",
        "children": [
          makeInfo("IBS / CBS - Total", "nfe_base_calculo_ibs_cbs", "vBCIBSCBS"),
          makeInfo("IBS UF Diferimento - Total", "nfe_ibs_uf_diferimento", "vDif"),
          makeInfo("IBS UF Devolução Tributos - Total", "nfe_ibs_uf_devolucao_tributos", "vDevTrib"),
          makeInfo("IBS UF - Total", "nfe_ibs_uf_valor_total", "vIBSUF"),
          makeInfo("IBS Município Diferimento - Total", "nfe_ibs_municipio_diferimento", "vDif"),
          makeInfo("IBS Município Devolução Tributos - Total", "nfe_ibs_municipio_devolucao_tributos", "vDevTrib"),
          makeInfo("IBS Município - Total", "nfe_ibs_municipio_valor_total", "vIBSMun"),
          makeInfo("IBS - Total", "nfe_ibs_valor_total", "vIBS"),
          makeInfo("IBS Crédito Presumido - Total", "nfe_ibs_credito_presumido", "vCredPres"),
          makeInfo("IBS Crédito Presumido (Cond. Susp.) - Total", "nfe_ibs_credito_presumido_suspenso", "vCredPresCondSus"),
          makeInfo("CBS Diferimento - Total", "nfe_cbs_diferimento", "vDif"),
          makeInfo("CBS Devolução Tributos - Total", "nfe_cbs_devolucao_tributos", "vDevTrib"),
          makeInfo("CBS - Total", "nfe_cbs_valor_total", "vCBS"),
          makeInfo("CBS Crédito Presumido - Total", "nfe_cbs_credito_presumido", "vCredPres"),
          makeInfo("CBS Crédito Presumido (Cond. Susp.) - Total", "nfe_cbs_credito_presumido_suspenso", "vCredPresCondSus"),
          makeInfo("IBS Monofásico - Total", "nfe_ibs_monofasico_valor_total", "vIBSMono"),
          makeInfo("CBS Monofásico - Total", "nfe_cbs_monofasico_valor_total", "vCBSMono"),
          makeInfo("IBS Monofásico Retenção - Total", "nfe_ibs_monofasico_retencao", "vIBSMonoReten"),
          makeInfo("CBS Monofásico Retenção - Total", "nfe_cbs_monofasico_retencao", "vCBSMonoReten"),
          makeInfo("IBS Monofásico Retido - Total", "nfe_ibs_monofasico_retido", "vIBSMonoRet"),
          makeInfo("CBS Monofásico Retido - Total", "nfe_cbs_monofasico_retido", "vCBSMonoRet"),
          makeInfo("IBS Estorno de Crédito - Total", "nfe_ibs_estorno_credito", "vIBSEstCred"),
          makeInfo("CBS Estorno de Crédito - Total", "nfe_cbs_estorno_credito", "vCBSEstCred"),
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "Transportador",
        "children": [
          makeInfo("CNPJ - Transp", "nfe_transp_cnpj", "CNPJ"),
          makeInfo("Razão Social - Transp", "nfe_transp_nome", "xNome"),
          makeInfo("Inscrição Estadual - Transp", "nfe_transp_ie", "IE"),
          makeInfo("Município - Transp", "nfe_transp_mun", "xMun"),
          makeInfo("UF - Transp", "nfe_transp_uf", "UF"),
          makeInfo("Volume - Transp", "nfe_transp_vol", "qVol"),
          makeInfo("Espécie - Transp", "nfe_transp_esp", "esp"),
          makeInfo("Peso Líquido - Transp", "nfe_transp_pesol", "pesoL"),
          makeInfo("Peso Bruto - Transp", "nfe_transp_pesob", "pesoB"),
          makeInfo("Veiculo Placa - Transp", "nfe_transp_veiculo_placa", "placa"),
          makeInfo("Veiculo UF - Transp", "nfe_transp_veiculo_uf", "UF"),
          makeInfo("Veiculo RNTC - Transp", "nfe_transp_veiculo_rntc", "RNTC"),
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "Produtos",
        "children": [
          makeItem("Código - Produto", "prod_cod", "cProd"),
          makeItem("EAN - Produto", "prod_ean", "cEAN"),
          makeItem("Nome - Produto", "prod_nome", "xProd"),
          makeItem("Número - Produto", "prod_numero", "nItem"),
          makeItem("NCM - Produto", "prod_ncm", "NCM"),
          makeItem("CEST - Produto", "prod_cest", "CEST"),
          makeItem("CFOP - Produto", "prod_cfop", "CFOP"),
          makeItem("Valor - Produto", "prod_vl_opr", "vProd"),
          makeItem("EAN Tribu. - Produto", "prod_ean_trib", "cEANTrib"),
          makeItem("Desconto - Produto", "prod_desc", "vDesc"),
          makeItem("Unidade - Produto", "prod_un", "uCom"),
          makeItem("Quantidade - Produto", "prod_quanti", "qCom"),
          makeItem("Valor Unitário - Produto", "prod_unit", "vUnCom"),
          makeItem("Unidade Tribu. - Produto", "prod_un_trib", "uTrib"),
          makeItem("Quantidade Tribu. - Produto", "prod_quanti_trib", "qTrib"),
          makeItem("Valor Unitário Tribu. - Produto", "prod_unit_trib", "vUnTrib"),
          makeItem("IPI CST - Produto", "prod_cst_ipi", "pIPI"),
          makeItem("IPI BC - Produto", "prod_vl_bc_ipi", "vBC"),
          makeItem("PIS CST - Produto", "prod_cst_pis", "CST"),
          makeItem("PIS BC - Produto", "prod_vl_bc_pis", "vBC"),
          makeItem("COFINS CST - Produto", "prod_cst_cofins", "CST"),
          makeItem("COFINS BC - Produto", "prod_vl_bc_cofins", "vBC"),
          makeItem("ICMS CST - Produto", "prod_cst_icms", "CST"),
          makeItem("ICMS BC - Produto", "prod_vl_bc_icms", "vBC"),
          makeItem("ICMS BCST - Produto", "prod_vl_bc_icms_st", "vBCST"),
          makeItem("ICMS - Produto", "prod_vl_icms", "vICMS"),
          makeItem("Aliq. ICMS - Produto", "prod_aliq_icms", "pICMS"),
          makeItem("MVA ST - Produto", "prod_vl_mva_st", "pMVAST"),
          makeItem("ICMS ST - Produto", "prod_vl_icms_st", "vICMSST"),
          makeItem("Aliq. ICMS ST - Produto", "prod_aliq_icms_st", "pICMSST"),
          makeItem("IPI - Produto", "prod_vl_ipi", "vIPI"),
          makeItem("Aliq. IPI - Produto", "prod_aliq_ipi", "pIPI"),
          makeItem("PIS - Produto", "prod_vl_pis", "vPIS"),
          makeItem("COFINS - Produto", "prod_vl_cofins", "vCOFINS"),
          makeItem("Outras Despesas - Produto", "prod_vl_outro", "vOutro"),
          makeItem("IBS/CBS CST - Produto", "prod_ibs_cbs_cst", "CST"),
          makeItem("IBS/CBS Class. Tributária - Produto", "prod_ibs_cbs_class_tributaria", "cClassTrib"),
          makeItem("IBS/CBS Base Cálculo - Produto", "prod_ibs_cbs_base_calculo", "vBC"),
          makeItem("IBS UF Alíquota - Produto", "prod_ibs_uf_aliquota", "pIBSUF"),
          makeItem("IBS UF Redução Alíquota - Produto", "prod_ibs_uf_reducao_aliquota", "pRedAliq"),
          makeItem("IBS UF Alíquota Efetiva - Produto", "prod_ibs_uf_aliquota_efetiva", "pAliqEfet"),
          makeItem("IBS UF Valor - Produto", "prod_ibs_uf_valor", "vIBSUF"),
          makeItem("IBS Município Alíquota - Produto", "prod_ibs_municipio_aliquota", "pIBSMun"),
          makeItem("IBS Município Redução Alíquota - Produto", "prod_ibs_municipio_reducao_aliquota", "pRedAliq"),
          makeItem("IBS Município Alíquota Efetiva - Produto", "prod_ibs_municipio_aliquota_efetiva", "pAliqEfet"),
          makeItem("IBS Município Valor - Produto", "prod_ibs_municipio_valor", "vIBSMun"),
          makeItem("IBS Valor Total - Produto", "prod_ibs_valor_total", "vIBS"),
          makeItem("CBS Alíquota - Produto", "prod_cbs_aliquota", "pCBS"),
          makeItem("CBS Valor - Produto", "prod_cbs_valor", "vCBS"),
          makeItem("CBS Redução Alíquota - Produto", "prod_cbs_reducao_aliquota", "pRedAliq"),
          makeItem("CBS Alíquota Efetiva - Produto", "prod_cbs_aliquota_efetiva", "pAliqEfet"),
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "Cálculos",
        "children": [
          makeItem("Nome - Cálculo", "calc_nome", "nome"),
          makeItem("Valido de - Cálculo", "calc_valido_de", "valido_de"),
          makeItem("Valido até - Cálculo", "calc_valido_ate", "valido_ate"),
          makeItem("ICMS - Cálculo", "calc_icms", "icms"),
          makeItem("Class. Nome - Cálculo", "calc_classi_nome", "nome"),
          makeItem("Class. Código Receita - Cálculo", "calc_classi_cod", "codigo_receita"),
          makeItem("MVA - Cálculo", "calc_mva", "mva"),
          makeItem("Valor FCP calculado - Cálculo", "calc_fcp", "valor_fcp"),
          makeItem("Valor ICM calculado - Cálculo", "calc_icms_ant", "valor_icms_ant"),
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "Observações",
        "children": [
          makeInfo("Fisico - Info", "nfe_inf_fisico", "infAdFisco"),
          makeInfo("CPL - Info", "nfe_inf_cpl", "infCpl"),
          makeInfo("Resp. CNPJ - Info", "nfe_inf_resp_cnpj", "CNPJ"),
          makeInfo("Resp. Contato - Info", "nfe_inf_resp_contato", "xContato"),
          makeInfo("Resp. Email - Info", "nfe_inf_resp_email", "email"),
          makeInfo("Resp. Fone - Info", "nfe_inf_resp_fone", "fone"),
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      }
    ],
    "_id": uuidv4(),
    checked: 0,
    isOpen: true
  }

  return itens

}

export const sorted_tags_nfces = [
  { id: uuidv4(), name: "Chave", xml: "nfe_chv", tag: "NFC-e", value: "string" },
  { id: uuidv4(), name: "Modelo", xml: "nfe_cod_mod", tag: "NFC-e", value: "string" },
  { id: uuidv4(), name: "Série", xml: "nfe_ser", tag: "NFC-e", value: "string" },
  { id: uuidv4(), name: "Número", xml: "nfe_num_doc", tag: "NFC-e", value: "string" },
  { id: uuidv4(), name: "Data Emissão", xml: "nfe_dt_doc", tag: "NFC-e", value: "data" },
  { id: uuidv4(), name: "Data de Entrada/Saída", xml: "nfe_dt_e_s", tag: "NFC-e", value: "data" },
  { id: uuidv4(), name: "Código Estado", xml: "nfe_cod_estado", tag: "NFC-e", value: "string" },
  { id: uuidv4(), name: "Código Numérico", xml: "nfe_cod_num", tag: "NFC-e", value: "string" },
  { id: uuidv4(), name: "Natureza Operação", xml: "nfe_nat_op", tag: "NFC-e", value: "string" },
  { id: uuidv4(), name: "Processo de Emissão", xml: "nfe_proc_emi", tag: "NFC-e", value: "string" },
  { id: uuidv4(), name: "Tipo de Emissão", xml: "nfe_tp_emis", tag: "NFC-e", value: "string" },
  { id: uuidv4(), name: "Tipo da Nota Fiscal", xml: "nfe_tp_nf", tag: "NFC-e", value: "string" },
  { id: uuidv4(), name: "CNPJ - Emit", xml: "nfe_emit_cnpj", tag: "Emitente", value: "string" },
  { id: uuidv4(), name: "Razão Social - Emit", xml: "nfe_emit_nome", tag: "Emitente", value: "string" },
  { id: uuidv4(), name: "Nome Fantasia - Emit", xml: "nfe_emit_fant", tag: "Emitente", value: "string" },
  { id: uuidv4(), name: "Inscrição Estadual - Emit", xml: "nfe_emit_ie", tag: "Emitente", value: "string" },
  { id: uuidv4(), name: "UF - Emit", xml: "nfe_emit_uf", tag: "Emitente", value: "string" },
  { id: uuidv4(), name: "CNPJ - Dest", xml: "nfe_dest_cnpj", tag: "Destinatário", value: "string" },
  { id: uuidv4(), name: "Razão Social - Dest", xml: "nfe_dest_nome", tag: "Destinatário", value: "string" },
  { id: uuidv4(), name: "Inscrição Estadual - Dest", xml: "nfe_dest_ie", tag: "Destinatário", value: "string" },
  { id: uuidv4(), name: "UF - Dest", xml: "nfe_dest_uf", tag: "Destinatário", value: "string" },
  { id: uuidv4(), name: "BC - Total", xml: "nfe_vl_bc_icms", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "BC ST - Total", xml: "nfe_vl_bc_icms_st", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "ICMS - Total", xml: "nfe_vl_icms", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "ICMS ST - Total", xml: "nfe_vl_icms_st", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "IPI - Total", xml: "nfe_vl_ipi", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "Frete - Total", xml: "nfe_vl_frt", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "NFCE - Total", xml: "nfe_vl_nfe", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "Produto - Total", xml: "nfe_vl_merc", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "Desconto - Total", xml: "nfe_vl_desc", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "Outras Despesas - Total", xml: "nfe_vl_outro", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "IPI Devolução - Total", xml: "nfe_ipi_devol", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "PIS - Total", xml: "nfe_vl_pis", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "FCP - Total", xml: "nfe_vl_fcp", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "FCP ST - Total", xml: "nfe_vl_fcp_st", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "COFINS - Total", xml: "nfe_vl_cofins", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "IBS / CBS - Total", xml: "nfe_base_calculo_ibs_cbs", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "IBS UF Diferimento - Total", xml: "nfe_ibs_uf_diferimento", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "IBS UF Devolução Tributos - Total", xml: "nfe_ibs_uf_devolucao_tributos", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "IBS UF - Total", xml: "nfe_ibs_uf_valor_total", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "IBS Município Diferimento - Total", xml: "nfe_ibs_municipio_diferimento", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "IBS Município Devolução Tributos - Total", xml: "nfe_ibs_municipio_devolucao_tributos", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "IBS Município - Total", xml: "nfe_ibs_municipio_valor_total", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "IBS - Total", xml: "nfe_ibs_valor_total", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "IBS Crédito Presumido - Total", xml: "nfe_ibs_credito_presumido", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "IBS Crédito Presumido (Cond. Susp.) - Total", xml: "nfe_ibs_credito_presumido_suspenso", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "CBS Diferimento - Total", xml: "nfe_cbs_diferimento", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "CBS Devolução Tributos - Total", xml: "nfe_cbs_devolucao_tributos", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "CBS - Total", xml: "nfe_cbs_valor_total", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "CBS Crédito Presumido - Total", xml: "nfe_cbs_credito_presumido", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "CBS Crédito Presumido (Cond. Susp.) - Total", xml: "nfe_cbs_credito_presumido_suspenso", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "IBS Monofásico - Total", xml: "nfe_ibs_monofasico_valor_total", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "CBS Monofásico - Total", xml: "nfe_cbs_monofasico_valor_total", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "IBS Monofásico Retenção - Total", xml: "nfe_ibs_monofasico_retencao", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "CBS Monofásico Retenção - Total", xml: "nfe_cbs_monofasico_retencao", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "IBS Monofásico Retido - Total", xml: "nfe_ibs_monofasico_retido", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "CBS Monofásico Retido - Total", xml: "nfe_cbs_monofasico_retido", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "IBS Estorno de Crédito - Total", xml: "nfe_ibs_estorno_credito", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "CBS Estorno de Crédito - Total", xml: "nfe_cbs_estorno_credito", tag: "Valores Totais", value: "number" },
  { id: uuidv4(), name: "CNPJ - Transp", xml: "nfe_transp_cnpj", tag: "Transportador", value: "string" },
  { id: uuidv4(), name: "Razão Social - Transp", xml: "nfe_transp_nome", tag: "Transportador", value: "string" },
  { id: uuidv4(), name: "Inscrição Estadual - Transp", xml: "nfe_transp_ie", tag: "Transportador", value: "string" },
  { id: uuidv4(), name: "Município - Transp", xml: "nfe_transp_mun", tag: "Transportador", value: "string" },
  { id: uuidv4(), name: "UF - Transp", xml: "nfe_transp_uf", tag: "Transportador", value: "string" },
  { id: uuidv4(), name: "Volume - Transp", xml: "nfe_transp_vol", tag: "Transportador", value: "string" },
  { id: uuidv4(), name: "Espécie - Transp", xml: "nfe_transp_esp", tag: "Transportador", value: "string" },
  { id: uuidv4(), name: "Peso Líquido - Transp", xml: "nfe_transp_pesol", tag: "Transportador", value: "number" },
  { id: uuidv4(), name: "Peso Bruto - Transp", xml: "nfe_transp_pesob", tag: "Transportador", value: "number" },
  { id: uuidv4(), name: "Veiculo Placa - Transp", xml: "nfe_transp_veiculo_placa", tag: "Transportador", value: "string", },
  { id: uuidv4(), name: "Veiculo UF - Transp", xml: "nfe_transp_veiculo_uf", tag: "Transportador", value: "string", },
  { id: uuidv4(), name: "Veiculo RNTC - Transp", xml: "nfe_transp_veiculo_rntc", tag: "Transportador", value: "string", },
  { id: uuidv4(), name: "Código - Produto", xml: "prod_cod", tag: "Produtos", value: "string" },
  { id: uuidv4(), name: "EAN - Produto", xml: "prod_ean", tag: "Produtos", value: "string" },
  { id: uuidv4(), name: "Nome - Produto", xml: "prod_nome", tag: "Produtos", value: "string" },
  { id: uuidv4(), name: "Número - Produto", xml: "prod_numero", tag: "Produtos", value: "string" },
  { id: uuidv4(), name: "NCM - Produto", xml: "prod_ncm", tag: "Produtos", value: "string" },
  { id: uuidv4(), name: "CEST - Produto", xml: "prod_cest", tag: "Produtos", value: "string" },
  { id: uuidv4(), name: "CFOP - Produto", xml: "prod_cfop", tag: "Produtos", value: "string" },
  { id: uuidv4(), name: "Valor - Produto", xml: "prod_vl_opr", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "EAN Tribu. - Produto", xml: "prod_ean_trib", tag: "Produtos", value: "string" },
  { id: uuidv4(), name: "Desconto - Produto", xml: "prod_desc", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "Unidade - Produto", xml: "prod_un", tag: "Produtos", value: "string" },
  { id: uuidv4(), name: "Quantidade - Produto", xml: "prod_quanti", tag: "Produtos", value: "string" },
  { id: uuidv4(), name: "Valor Unitário - Produto", xml: "prod_unit", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "Unidade Tribu. - Produto", xml: "prod_un_trib", tag: "Produtos", value: "string" },
  { id: uuidv4(), name: "Quantidade Tribu. - Produto", xml: "prod_quanti_trib", tag: "Produtos", value: "string" },
  { id: uuidv4(), name: "Valor Unitário Tribu. - Produto", xml: "prod_unit_trib", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "IPI CST - Produto", xml: "prod_cst_ipi", tag: "Produtos", value: "string" },
  { id: uuidv4(), name: "IPI BC - Produto", xml: "prod_vl_bc_ipi", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "PIS CST - Produto", xml: "prod_cst_pis", tag: "Produtos", value: "string" },
  { id: uuidv4(), name: "PIS BC - Produto", xml: "prod_vl_bc_pis", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "COFINS CST - Produto", xml: "prod_cst_cofins", tag: "Produtos", value: "string" },
  { id: uuidv4(), name: "COFINS BC - Produto", xml: "prod_vl_bc_cofins", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "ICMS CST - Produto", xml: "prod_cst_icms", tag: "Produtos", value: "string" },
  { id: uuidv4(), name: "ICMS BC - Produto", xml: "prod_vl_bc_icms", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "ICMS BC ST - Produto", xml: "prod_vl_bc_icms_st", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "ICMS - Produto", xml: "prod_vl_icms", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "Aliq. ICMS - Produto", xml: "prod_aliq_icms", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "MVA ST - Produto", xml: "prod_vl_mva_st", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "ICMS ST - Produto", xml: "prod_vl_icms_st", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "Aliq. ICMS ST - Produto", xml: "prod_aliq_icms_st", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "IPI - Produto", xml: "prod_vl_ipi", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "Aliq. IPI - Produto", xml: "prod_aliq_ipi", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "PIS - Produto", xml: "prod_vl_pis", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "COFINS - Produto", xml: "prod_vl_cofins", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "Outras Despesas - Produto", xml: "prod_vl_outro", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "IBS/CBS CST - Produto", xml: "prod_ibs_cbs_cst", tag: "Produtos", value: "string" },
  { id: uuidv4(), name: "IBS/CBS Class. Tributária - Produto", xml: "prod_ibs_cbs_class_tributaria", tag: "Produtos", value: "string" },
  { id: uuidv4(), name: "IBS/CBS Base Cálculo - Produto", xml: "prod_ibs_cbs_base_calculo", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "IBS UF Alíquota - Produto", xml: "prod_ibs_uf_aliquota", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "IBS UF Redução Alíquota - Produto", xml: "prod_ibs_uf_reducao_aliquota", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "IBS UF Alíquota Efetiva - Produto", xml: "prod_ibs_uf_aliquota_efetiva", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "IBS UF Valor - Produto", xml: "prod_ibs_uf_valor", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "IBS Município Alíquota - Produto", xml: "prod_ibs_municipio_aliquota", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "IBS Município Redução Alíquota - Produto", xml: "prod_ibs_municipio_reducao_aliquota", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "IBS Município Alíquota Efetiva - Produto", xml: "prod_ibs_municipio_aliquota_efetiva", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "IBS Município Valor - Produto", xml: "prod_ibs_municipio_valor", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "IBS Valor Total - Produto", xml: "prod_ibs_valor_total", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "CBS Alíquota - Produto", xml: "prod_cbs_aliquota", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "CBS Valor - Produto", xml: "prod_cbs_valor", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "CBS Redução Alíquota - Produto", xml: "prod_cbs_reducao_aliquota", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "CBS Alíquota Efetiva - Produto", xml: "prod_cbs_aliquota_efetiva", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "Nome - Cálculo", xml: "calc_nome", tag: "Produtos", value: "calculo" },
  { id: uuidv4(), name: "Valido de - Cálculo", xml: "calc_valido_de", tag: "Produtos", value: "data" },
  { id: uuidv4(), name: "Valido até - Cálculo", xml: "calc_valido_ate", tag: "Produtos", value: "data" },
  { id: uuidv4(), name: "ICMS - Cálculo", xml: "calc_icms", tag: "Produtos", value: "boolean" },
  { id: uuidv4(), name: "Class. Nome - Cálculo", xml: "calc_classi_nome", tag: "Produtos", value: "classificacao" },
  { id: uuidv4(), name: "Class. Código Receita - Cálculo", xml: "calc_classi_cod", tag: "Produtos", value: "string" },
  { id: uuidv4(), name: "MVA - Cálculo", xml: "calc_mva", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "Valor FCP calculado - Cálculo", xml: "calc_fcp", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "Valor ICM calculado - Cálculo", xml: "calc_icms_ant", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "Fisico - Info", xml: "nfe_inf_fisico", tag: "NFE-e", value: "string" },
  { id: uuidv4(), name: "CPL - Info", xml: "nfe_inf_cpl", tag: "NFE-e", value: "string" },
  { id: uuidv4(), name: "Resp. CNPJ - Info", xml: "nfe_inf_resp_cnpj", tag: "NFE-e", value: "string" },
  { id: uuidv4(), name: "Resp. Contato - Info", xml: "nfe_inf_resp_contato", tag: "NFE-e", value: "string" },
  { id: uuidv4(), name: "Resp. Email - Info", xml: "nfe_inf_resp_email", tag: "NFE-e", value: "string" },
  { id: uuidv4(), name: "Resp. Fone - Info", xml: "nfe_inf_resp_fone", tag: "NFE-e", value: "string" }
]

export function values_nfse() {

  let order = 0

  const makeInfo = (name: string, xml: string, tag = ""): NodeData => ({ id: uuidv4(), name, xml, checked: 0, campo: "info", order: order += 1, tag });
  const makeItem = (name: string, xml: string, tag = ""): NodeData => ({ id: uuidv4(), name, xml, checked: 0, campo: "item", order: order += 1, tag });

  let itens: NodeData = {
    "name": "NFS-es",
    "children": [
      {
        "name": "NFS-e",
        "children": [
          makeInfo("Chave - NFS-e", "nfse_chave", "chave"),
          makeInfo("Local Prestação - NFS-e", "nfse_local_prestacao", "xLocPrestacao"),
          makeInfo("Num. NFSe - NFS-e", "nfse_cod_nfse", "nNFSe"),
          makeInfo("Cod. Local Incid - NFS-e", "nfse_cod_local_incid", "cLocIncid"),
          makeInfo("Local Incid - NFS-e", "nfse_local_incid", "xLocIncid"),
          makeInfo("Tributação Nacional - NFS-e", "nfse_trib_nac", "xTribNac"),
          makeInfo("Tributação Municipal - NFS-e", "nfse_trib_mun", "xTribMun"),
          makeInfo("Local Emissão - NFS-e", "nfse_local_emit", "xLocEmi"),
          makeInfo("Ambiente Gerenciamento - NFS-e", "nfse_amb_ger", "ambGer"),
          makeInfo("Tipo Emissão - NFS-e", "nfse_tipo_emis", "tpEmis"),
          makeInfo("Processo Emissão - NFS-e", "nfse_proc_emis", "procEmi"),
          makeInfo("Cod. Status - NFS-e", "nfse_cod_stat", "cStat"),
          makeInfo("Data Processamento - NFS-e", "nfse_data_proc", "dhProc"),
          makeInfo("Numero NFSe - NFS-e", "nfse_num_nfse", "nDFSe"),
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "Emitente",
        "children": [
          makeInfo("CNPJ - Emit", "nfse_emit_cnpj", "CNPJ"),
          makeInfo("IM - Emit", "nfse_emit_im", "IM"),
          makeInfo("Nome - Emit", "nfse_emit_nome", "xNome"),
          makeInfo("UF - Emit", "nfse_emit_uf", "UF"),
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "Valores",
        "children": [
          makeInfo("Valor Total Retido - Valores", "nfse_valor_total_ret", "vTotalRet"),
          makeInfo("Valor Liq - Valores", "nfse_valor_liq", "vLiq"),
          makeInfo("Valor Base Cálculo - Valores", "nfse_valor_base_calculo", "vBC"),
          makeInfo("Valor Aliquota Aplicada - Valores", "nfse_valor_aliquota_aplicada", "pAliqAplic"),
          makeInfo("Valor ISSQN - Valores", "nfse_valor_issqn", "vISSQN")
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "Documento",
        "children": [
          makeInfo("CNPJ - Documento", "nfse_tipo_amb", "tpAmb"),
          makeInfo("Data Emissão - Documento", "nfse_data_emit", "dhEmi"),
          makeInfo("Serie - Documento", "nfse_serie", "serie"),
          makeInfo("Num. DPS - Documento", "nfse_num_doc_prest_serv", "nDPS"),
          makeInfo("Competencia - Documento", "nfse_data_competencia", "dCompet"),
          makeInfo("Tipo Emissão - Documento", "nfse_tipo_emit", "tpEmit"),
          makeInfo("Cod. Local Emissão - Documento", "nfse_cod_local_emi", "cLocEmi"),
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "Prestador",
        "children": [
          makeInfo("CNPJ - Prestador", "nfse_prest_cnpj", "CNPJ"),
          makeInfo("IM - Prestador", "nfse_prest_im", "IM"),
          makeInfo("Telefone - Prestador", "nfse_prest_fone", "fone"),
          makeInfo("E-Mail - Prestador", "nfse_prest_email", "email"),
          makeInfo("Op. Simples - Prestador", "nfse_prest_op_simples", "opSimpNac"),
          makeInfo("Simples - Prestador", "nfse_prest_regime_simples", "regApTribSN"),
          makeInfo("Especial - Prestador", "nfse_prest_regime_especial", "regEspTrib"),
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "Tomador",
        "children": [
          makeInfo("CNPJ - Tomador", "nfse_toma_cnpj", "CNPJ"),
          makeInfo("Nome - Tomador", "nfse_toma_nome", "xNome"),
          makeInfo("Cód. Município - Tomador", "nfse_toma_cod_municipio", "cMun"),
          makeInfo("CEP - Tomador", "nfse_toma_cep", "CEP"),
          makeInfo("Logradouro - Tomador", "nfse_toma_lgr", "xLgr"),
          makeInfo("Número - Tomador", "nfse_toma_nro", "nro"),
          makeInfo("Complemento - Tomador", "nfse_toma_cpl", "xCpl"),
          makeInfo("Bairro - Tomador", "nfse_toma_bairro", "xBairro"),
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "Serviço",
        "children": [
          makeInfo("Cod. Local - Serviço", "nfse_serv_cod_local_prestacao", "cLocPrestacao"),
          makeInfo("Cod. Nacional - Serviço", "nfse_serv_cod_trib_nac", "cTribNac"),
          makeInfo("Cod. Municipal - Serviço", "nfse_serv_cod_trib_mun", "cTribMun"),
          makeInfo("Descrição - Serviço", "nfse_serv_desc_servico", "xDescServ"),
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "Valores",
        "children": [
          makeInfo("Serviço - Valores", "nfse_valor_serv", "vServ"),
          makeInfo("Trib. ISSQN - Valores", "nfse_trib_issqn", "tribISSQN"),
          makeInfo("Ret. ISSQN - Valores", "nfse_tipo_ret_issqn", "tpRetISSQN"),
          makeInfo("Percentual Simples - Valores", "nfse_percentual_tot_trib_simples", "pTotTribSN"),
          makeInfo("Base de Cálculo PIS/COFINS - Valores", "nfse_base_calculo_pis_cofins", "vBCPisCofins"),
          makeInfo("Alíquota PIS - Valores", "nfse_aliquota_pis", "pAliqPis"),
          makeInfo("Alíquota COFINS - Valores", "nfse_aliquota_cofins", "pAliqCofins"),
          makeInfo("Valor PIS - Valores", "nfse_valor_pis", "vPis"),
          makeInfo("Valor COFINS - Valores", "nfse_valor_cofins", "vCofins"),
          makeInfo("Tipo de Retorno PIS/COFINS - Valores", "nfse_tipo_retorno_pis_cofins", "tpRetPisCofins"),
          makeInfo("Valor Retido CP - Valores", "nfse_valor_retido_cp", "vRetCP"),
          makeInfo("Valor Retido IRRF - Valores", "nfse_valor_retido_irrf", "vRetIRRF"),
          makeInfo("Valor Retido CSLL - Valores", "nfse_valor_retido_csll", "vRetCSLL"),
          makeInfo("Valor Total Trib. Federais - Valores", "nfse_valor_total_tributos_federais", "vTotTribFed"),
          makeInfo("Valor Total Trib. Estaduais - Valores", "nfse_valor_total_tributos_estaduais", "vTotTribEst"),
          makeInfo("Valor Total Trib. Municipais - Valores", "nfse_valor_total_tributos_municipais", "vTotTribMun"),
          makeInfo("Percentual Total Trib. Federais - Valores", "nfse_percentual_total_tributos_federais", "pTotTribFed"),
          makeInfo("Percentual Total Trib. Estaduais - Valores", "nfse_percentual_total_tributos_estaduais", "pTotTribEst"),
          makeInfo("Percentual Total Trib. Municipais - Valores", "nfse_percentual_total_tributos_municipais", "pTotTribMun"),
          makeInfo("Indicador Total Trib. - Valores", "nfse_indicador_total_tributos", "indTotTrib"),
          makeInfo("Percentual Total Trib. Simples Nacional - Valores", "nfse_percentual_total_tributos_simples_nacional", "pTotTribSN"),
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "IBS e CBS",
        "children": [
          makeInfo("Código Local Incidência - Valores", "nfse_cod_local_incide", "cLocalidadeIncid"),
          makeInfo("Descrição Local Incidência - Valores", "nfse_desc_local_incide", "xLocalidadeIncid"),
          makeInfo("Valor Base Cálculo IBS/CBS - Valores", "nfse_valor_base_calculo_ibscbs", "vBC"),
          makeInfo("Valor Cálculo REE Repartição Residência - Valores", "nfse_valor_calculo_ree_reparticao_residencia", "vCalcReeRepRes"),
          makeInfo("Percentual IBS UF - Valores", "nfse_percentual_ibs_uf", "pIBSUF"),
          makeInfo("Percentual Alíquota Efetiva UF - Valores", "nfse_percentual_aliquota_efetiva_uf", "pAliqEfetUF"),
          makeInfo("Percentual IBS Município - Valores", "nfse_percentual_ibs_municipio", "pIBSMun"),
          makeInfo("Percentual Alíquota Efetiva Município - Valores", "nfse_percentual_aliquota_efetiva_municipio", "pAliqEfetMun"),
          makeInfo("Percentual CBS Federal - Valores", "nfse_percentual_cbs_federal", "pCBS"),
          makeInfo("Percentual Alíquota Efetiva CBS - Valores", "nfse_percentual_aliquota_efetiva_cbs", "pAliqEfetCBS"),
          makeInfo("Valor Total NF - Valores", "nfse_valor_total_nf", "vTotNF"),
          makeInfo("Valor Total IBS - Valores", "nfse_valor_total_ibs", "vIBSTot"),
          makeInfo("Valor Total IBS UF - Valores", "nfse_valor_total_ibs_uf", "vIBSUF"),
          makeInfo("Valor Total IBS Município - Valores", "nfse_valor_total_ibs_municipio", "vIBSMun"),
          makeInfo("Valor Total CBS - Valores", "nfse_valor_total_cbs", "vCBS"),
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
      {
        "name": "Cálculos",
        "children": [
          makeItem("Nome - Cálculo", "calc_nome", "nome"),
          makeItem("Valido de - Cálculo", "calc_valido_de", "valido_de"),
          makeItem("Valido até - Cálculo", "calc_valido_ate", "valido_ate"),
          makeItem("ICMS - Cálculo", "calc_icms", "icms"),
          makeItem("Class. Nome - Cálculo", "calc_classi_nome", "nome"),
          makeItem("Class. Código Receita - Cálculo", "calc_classi_cod", "codigo_receita"),
          makeItem("MVA - Cálculo", "calc_mva", "mva"),
          makeItem("Valor FCP calculado - Cálculo", "calc_fcp", "valor_fcp"),
          makeItem("Valor ICM calculado - Cálculo", "calc_icms_ant", "valor_icms_ant"),
        ],
        "_id": uuidv4(),
        checked: 0,
        isOpen: false
      },
    ],
    "_id": uuidv4(),
    checked: 0,
    isOpen: true
  }

  return itens

}

export const sorted_tags_nfses = [
  { id: uuidv4(), name: "Chave - NFS-e", tag: "NFS-E", xml: "nfse_chave", value: "string" },
  { id: uuidv4(), name: "Local Emissão - NFS-e", tag: "NFS-E", xml: "nfse_local_emit", value: "string" },
  { id: uuidv4(), name: "Local Prestação - NFS-e", tag: "NFS-E", xml: "nfse_local_prestacao", value: "string" },
  { id: uuidv4(), name: "Num. NFSe - NFS-e", tag: "NFS-E", xml: "nfse_cod_nfse", value: "string" },
  { id: uuidv4(), name: "Cod. Local Incid - NFS-e", tag: "NFS-E", xml: "nfse_cod_local_incid", value: "string" },
  { id: uuidv4(), name: "Local Incid - NFS-e", tag: "NFS-E", xml: "nfse_local_incid", value: "string" },
  { id: uuidv4(), name: "Tributação Nacional - NFS-e", tag: "NFS-E", xml: "nfse_trib_nac", value: "string" },
  { id: uuidv4(), name: "Tributação Municipal - NFS-e", tag: "NFS-E", xml: "nfse_trib_mun", value: "string" },
  { id: uuidv4(), name: "Ambiente Gerenciamento - NFS-e", tag: "NFS-E", xml: "nfse_amb_ger", value: "string" },
  { id: uuidv4(), name: "Tipo Emissão - NFS-e", tag: "NFS-E", xml: "nfse_tipo_emis", value: "string" },
  { id: uuidv4(), name: "Processo Emissão - NFS-e", tag: "NFS-E", xml: "nfse_proc_emis", value: "string" },
  { id: uuidv4(), name: "Cod. Status - NFS-e", tag: "NFS-E", xml: "nfse_cod_stat", value: "string" },
  { id: uuidv4(), name: "Data Processamento - NFS-e", tag: "NFS-E", xml: "nfse_data_proc", value: "data" },
  { id: uuidv4(), name: "Numero NFSe - NFS-e", tag: "NFS-E", xml: "nfse_num_nfse", value: "string" },
  { id: uuidv4(), name: "CNPJ - Emit", xml: "nfse_emit_cnpj", tag: "Emitente", value: "string" },
  { id: uuidv4(), name: "IM - Emit", xml: "nfse_emit_im", tag: "Emitente", value: "string" },
  { id: uuidv4(), name: "Nome - Emit", xml: "nfse_emit_nome", tag: "Emitente", value: "string" },
  { id: uuidv4(), name: "UF - Emit", xml: "nfse_emit_uf", tag: "Emitente", value: "string" },
  { id: uuidv4(), name: "Valor Toal Retido - Valores", xml: "nfse_valor_total_ret", tag: "Valores", value: "number" },
  { id: uuidv4(), name: "Valor Liq - Valores", xml: "nfse_valor_liq", tag: "Valores", value: "number" },
  { id: uuidv4(), name: "CNPJ - Documento", tag: "Documento", xml: "nfse_tipo_amb", value: "string" },
  { id: uuidv4(), name: "Data Emissão - Documento", tag: "Documento", xml: "nfse_data_emit", value: "data" },
  { id: uuidv4(), name: "Serie - Documento", tag: "Documento", xml: "nfse_serie", value: "string" },
  { id: uuidv4(), name: "Num. DPS - Documento", tag: "Documento", xml: "nfse_num_doc_prest_serv", value: "string" },
  { id: uuidv4(), name: "Competencia - Documento", tag: "Documento", xml: "nfse_data_competencia", value: "string" },
  { id: uuidv4(), name: "Tipo Emissão - Documento", tag: "Documento", xml: "nfse_tipo_emit", value: "string" },
  { id: uuidv4(), name: "Cod. Local Emissão - Documento", tag: "Documento", xml: "nfse_cod_local_emi", value: "string" },
  { id: uuidv4(), name: "CNPJ - Prestador", xml: "nfse_prest_cnpj", tag: "Documento", value: "string" },
  { id: uuidv4(), name: "IM - Prestador", xml: "nfse_prest_im", tag: "Documento", value: "string" },
  { id: uuidv4(), name: "Op. Simples - Prestador", xml: "nfse_prest_op_simples", tag: "Documento", value: "string" },
  { id: uuidv4(), name: "Simples - Prestador", xml: "nfse_prest_regime_simples", tag: "Documento", value: "string" },
  { id: uuidv4(), name: "Especial - Prestador", xml: "nfse_prest_regime_especial", tag: "Documento", value: "string" },
  { id: uuidv4(), name: "CNPJ - Tomador", xml: "nfse_toma_cnpj", tag: "Documento", value: "string" },
  { id: uuidv4(), name: "Nome - Tomador", xml: "nfse_toma_nome", tag: "Documento", value: "string" },
  { id: uuidv4(), name: "Cod. Local - Serviço", xml: "nfse_serv_cod_local_prestacao", tag: "Documento", value: "string" },
  { id: uuidv4(), name: "Cod. Nacional - Serviço", xml: "nfse_serv_cod_trib_nac", tag: "Documento", value: "string" },
  { id: uuidv4(), name: "Cod. Municipal - Serviço", xml: "nfse_serv_cod_trib_mun", tag: "Documento", value: "string" },
  { id: uuidv4(), name: "Descrição - Serviço", xml: "nfse_serv_desc_servico", tag: "Documento", value: "string" },
  { id: uuidv4(), name: "Serviço - Valores", xml: "nfse_valor_serv", tag: "Documento", value: "string" },
  { id: uuidv4(), name: "Trib. ISSQN - Valores", xml: "nfse_trib_issqn", tag: "Documento", value: "string" },
  { id: uuidv4(), name: "Ret. ISSQN - Valores", xml: "nfse_tipo_ret_issqn", tag: "Documento", value: "string" },
  { id: uuidv4(), name: "Percentual Simples - Valores", xml: "nfse_percentual_tot_trib_simples", tag: "Documento", value: "string" },
  { id: uuidv4(), name: "Nome - Cálculo", xml: "calc_nome", tag: "Produtos", value: "calculo" },
  { id: uuidv4(), name: "Valido de - Cálculo", xml: "calc_valido_de", tag: "Produtos", value: "data" },
  { id: uuidv4(), name: "Valido até - Cálculo", xml: "calc_valido_ate", tag: "Produtos", value: "data" },
  { id: uuidv4(), name: "ICMS - Cálculo", xml: "calc_icms", tag: "Produtos", value: "boolean" },
  { id: uuidv4(), name: "Class. Nome - Cálculo", xml: "calc_classi_nome", tag: "Produtos", value: "classificacao" },
  { id: uuidv4(), name: "Class. Código Receita - Cálculo", xml: "calc_classi_cod", tag: "Produtos", value: "string" },
  { id: uuidv4(), name: "MVA - Cálculo", xml: "calc_mva", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "Valor FCP calculado - Cálculo", xml: "calc_fcp", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "Valor ICM calculado - Cálculo", xml: "calc_icms_ant", tag: "Produtos", value: "number" },
  { id: uuidv4(), name: "Base de Cálculo PIS/COFINS - Valores", xml: "nfse_base_calculo_pis_cofins", tag: "Documento", value: "number" },
  { id: uuidv4(), name: "Alíquota PIS - Valores", xml: "nfse_aliquota_pis", tag: "Documento", value: "string" },
  { id: uuidv4(), name: "Alíquota COFINS - Valores", xml: "nfse_aliquota_cofins", tag: "Documento", value: "string" },
  { id: uuidv4(), name: "Valor PIS - Valores", xml: "nfse_valor_pis", tag: "Documento", value: "number" },
  { id: uuidv4(), name: "Valor COFINS - Valores", xml: "nfse_valor_cofins", tag: "Documento", value: "number" },
  { id: uuidv4(), name: "Tipo de Retorno PIS/COFINS - Valores", xml: "nfse_tipo_retorno_pis_cofins", tag: "Documento", value: "string" },
  { id: uuidv4(), name: "Valor Retido CP - Valores", xml: "nfse_valor_retido_cp", tag: "Documento", value: "number" },
  { id: uuidv4(), name: "Valor Retido IRRF - Valores", xml: "nfse_valor_retido_irrf", tag: "Documento", value: "number" },
  { id: uuidv4(), name: "Valor Retido CSLL - Valores", xml: "nfse_valor_retido_csll", tag: "Documento", value: "number" },
  { id: uuidv4(), name: "Valor Total Tributos Federais - Valores", xml: "nfse_valor_total_tributos_federais", tag: "Documento", value: "number" },
  { id: uuidv4(), name: "Valor Total Tributos Estaduais - Valores", xml: "nfse_valor_total_tributos_estaduais", tag: "Documento", value: "number" },
  { id: uuidv4(), name: "Valor Total Tributos Municipais - Valores", xml: "nfse_valor_total_tributos_municipais", tag: "Documento", value: "number" },
  { id: uuidv4(), name: "Percentual Total Tributos Federais - Valores", xml: "nfse_percentual_total_tributos_federais", tag: "Documento", value: "string" },
  { id: uuidv4(), name: "Percentual Total Tributos Estaduais - Valores", xml: "nfse_percentual_total_tributos_estaduais", tag: "Documento", value: "string" },
  { id: uuidv4(), name: "Percentual Total Tributos Municipais - Valores", xml: "nfse_percentual_total_tributos_municipais", tag: "Documento", value: "string" },
  { id: uuidv4(), name: "Indicador Total Tributos - Valores", xml: "nfse_indicador_total_tributos", tag: "Documento", value: "string" },
  { id: uuidv4(), name: "Percentual Total Tributos Simples Nacional - Valores", xml: "nfse_percentual_total_tributos_simples_nacional", tag: "Documento", value: "number" },
  { id: uuidv4(), name: "Código Local Incidência - Valores", xml: "nfse_cod_local_incide", tag: "Documento", value: "number" },
  { id: uuidv4(), name: "Descrição Local Incidência - Valores", xml: "nfse_desc_local_incide", tag: "Documento", value: "number" },
  { id: uuidv4(), name: "Valor Base Cálculo IBS/CBS - Valores", xml: "nfse_valor_base_calculo_ibscbs", tag: "Documento", value: "number" },
  { id: uuidv4(), name: "Valor Cálculo REE Repartição Residência - Valores", xml: "nfse_valor_calculo_ree_reparticao_residencia", tag: "Documento", value: "number" },
  { id: uuidv4(), name: "Percentual IBS UF - Valores", xml: "nfse_percentual_ibs_uf", tag: "Documento", value: "number" },
  { id: uuidv4(), name: "Percentual Alíquota Efetiva UF - Valores", xml: "nfse_percentual_aliquota_efetiva_uf", tag: "Documento", value: "number" },
  { id: uuidv4(), name: "Percentual IBS Município - Valores", xml: "nfse_percentual_ibs_municipio", tag: "Documento", value: "number" },
  { id: uuidv4(), name: "Percentual Alíquota Efetiva Município - Valores", xml: "nfse_percentual_aliquota_efetiva_municipio", tag: "Documento", value: "number" },
  { id: uuidv4(), name: "Percentual CBS Federal - Valores", xml: "nfse_percentual_cbs_federal", tag: "Documento", value: "number" },
  { id: uuidv4(), name: "Percentual Alíquota Efetiva CBS - Valores", xml: "nfse_percentual_aliquota_efetiva_cbs", tag: "Documento", value: "number" },
  { id: uuidv4(), name: "Valor Total NF - Valores", xml: "nfse_valor_total_nf", tag: "Documento", value: "number" },
  { id: uuidv4(), name: "Valor Total IBS - Valores", xml: "nfse_valor_total_ibs", tag: "Documento", value: "number" },
  { id: uuidv4(), name: "Valor Total IBS UF - Valores", xml: "nfse_valor_total_ibs_uf", tag: "Documento", value: "number" },
  { id: uuidv4(), name: "Valor Total IBS Município - Valores", xml: "nfse_valor_total_ibs_municipio", tag: "Documento", value: "number" },
  { id: uuidv4(), name: "Valor Total CBS - Valores", xml: "nfse_valor_total_cbs", tag: "Documento", value: "number" },

]